import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';
import { pxArrayToRem, buttonClassName } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';

export const Contacts: StyleRule = ({ theme }) => ({
    gap: theme.siteVariables.spaces['space-8'],
    padding: pxArrayToRem([0, 18]),
    marginTop: pxToRem(13),
    marginBottom: pxToRem(30),
    [theme.screen.laptop]: {
        marginBottom: 0,
    },
});

export const EnquireContainer: StyleRule = {
    position: 'relative',
};

export const EnquireButton: StyleRule = {
    width: '100%',
};

export const SaveToDesignBoardContainer: StyleRule = {
    position: 'absolute',
    right: 0,
    top: 0,
};

export const ResposeRate: StyleRule = () => ({
    marginTop: pxToRem(45),
});

export const LinkButton: StyleRule = () => ({
    textDecoration: 'underline',
    '& > span': {
        marginRight: pxToRem(10),
    },
});

export const ProfileLink: StyleRule = () => ({
    [`&.${buttonClassName} `]: {
        textDecoration: 'none',
        width: '100%',
    },
    [`& .${svgIconClassName}`]: {
        width: pxToRem(24),
        height: pxToRem(24),
    },
});

export const SaveShareContainer: StyleRule = () => ({
    marginTop: 0,
});

export const ButtonHeart: StyleRule = ({ theme }) => ({
    width: pxToRem(48),
    height: pxToRem(48),
    [`&.${buttonClassName}`]: {
        border: `${pxToRem(1)} solid ${
            theme.siteVariables.colors.charcoal['250']
        }`,
        [`&:active`]: {
            border: `${pxToRem(1)} solid ${
                theme.siteVariables.colors.charcoal['250']
            }`,
        },
    },
});
